export default Object.freeze({
    OHYBARNA: 'Ohýbárna',
    //TODO: 'Dalši',
});
